module.exports = __webpack_public_path__ + "img/Rectangle 1451@2x.e95db3c7.png";